import React, { forwardRef } from 'react';

const IcInformational = forwardRef((properties, ref) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  ref,
  viewBox: "0 0 19 19",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M2.08301 7.08936C2.08301 4.32793 4.32158 2.08936 7.08301 2.08936H12.9163C15.6778 2.08936 17.9163 4.32793 17.9163 7.08936V12.9227C17.9163 15.6841 15.6778 17.9227 12.9163 17.9227H7.08301C4.32158 17.9227 2.08301 15.6841 2.08301 12.9227V7.08936Z",
  fill: "var(--info-icon-default)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M9.16634 13.5479L9.16634 10.0062C9.16634 9.54595 9.53944 9.17285 9.99967 9.17285C10.4599 9.17285 10.833 9.54595 10.833 10.0062L10.833 13.5479C10.833 14.0081 10.4599 14.3812 9.99967 14.3812C9.53944 14.3812 9.16634 14.0081 9.16634 13.5479Z",
  fill: "var(--info-icon-in-default)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: "9.99967",
  cy: "6.88102",
  fill: "white",
  r: "1.04167"
})));

export { IcInformational };
//# sourceMappingURL=ic-informational.js.map
